module.exports = __webpack_public_path__ + "media/images/europe-hover-60333966f3727507e4a4c718bcddf22f.png";